import { CircularProgress, FormControl, MenuItem, Select } from "@mui/material"
import React, { useEffect, useState } from "react"
import { useDispatch, useSelector } from "react-redux"
import {
  getAllSuborganizationGroup,
  setRequestSuborganizationGroup,
} from "../../../../redux/actions/Suborganizations"

export const SelectSuborgGroups = ({
  suborganizationGroupSelect,
  handleChange,
}) => {
  const [loading, setloading] = useState(false)

  const { suborganizationGroups } = useSelector(
    (state) => state.globalNotification,
  )
  const dispatch = useDispatch()

  const loadSuborgGroups = async () => {
    setloading(true)
    await dispatch(getAllSuborganizationGroup())
    setloading(false)
  }

  useEffect(() => {
    loadSuborgGroups()
    return () => {
      dispatch(setRequestSuborganizationGroup())
    }
  }, [])

  if (loading)
    return (
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          color: "#00a78f",
          width: 200,
        }}
      >
        <CircularProgress color="inherit" />
      </div>
    )
  return (
    <div style={{ width: "100%" }}>
      <FormControl variant="standard" sx={{ m: 1, minWidth: 200 }}>
        <Select
          labelId="demo-simple-select-standard-label"
          id="demo-simple-select-standard"
          value={suborganizationGroupSelect}
          onChange={handleChange}
          label="Exclusiones"
        >
          <MenuItem value={""}></MenuItem>
          {suborganizationGroups &&
            suborganizationGroups.map((i) => (
              <MenuItem
                key={i.suborganizationGroupId}
                value={i.suborganizationGroupId}
              >
                {i.suborganizationGroupDesc}
              </MenuItem>
            ))}
        </Select>
      </FormControl>
    </div>
  )
}
